import { Link } from 'gatsby';
import PropTypes from 'prop-types'
import React from 'react'
import SplitText from 'react-pose-text';
import { connect } from 'react-redux';
import { Button } from 'module-tsl-ui-elements';
import posed from 'react-pose';

import Search from './search';

import Logo from './logo';
import { CLOSE_MENU } from '../state/constants';

const ToAppear = posed.div({
  open: { opacity: 1, y: 0, transition: ({ after }) => ({ delay: after }) },
  closed: { opacity: 0, y: 20 }
});

const charPoses = {
  exit: { opacity: 0 },
  enter: {
    opacity: 1,
    transition: ({ charIndex }) => ({
      delay: (charIndex * 20) + 200,
      duration: 100,
    }),
  },
};

const Header = ({ closeMenu }) => (
  <header className="l-header">
    <Button className="btn-close-nav" onClick={closeMenu} theme="tertiary" icon="remove" type="button" />
    <Link to="/">
      <Logo />
      <ToAppear initialPose="closed" pose="open" after={400}>
        <span>
          <SplitText initialPose="exit" pose="enter" charPoses={charPoses}>
            UNIFYING DESIGN ACROSS TES
          </SplitText>
        </span>
      </ToAppear>
    </Link>
    <ToAppear initialPose="closed" pose="open" after={700}>
      <Search />
    </ToAppear>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: '',
}

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => ({
  closeMenu: () => dispatch({ type: CLOSE_MENU }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
